import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=4c63199a&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"
import style0 from "./Form.vue?vue&type=style&index=0&id=4c63199a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63199a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c63199a')) {
      api.createRecord('4c63199a', component.options)
    } else {
      api.reload('4c63199a', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=4c63199a&scoped=true", function () {
      api.rerender('4c63199a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/ui-components/news/Form.vue"
export default component.exports